import { EditProfile, Language } from 'components/Profile';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/Profile/desktop';
import Mobile from 'pages/Profile/mobile';
import Tablet from 'pages/Profile/tablet';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { AlertDialog } from 'shell/components';

const ProfilePage = () => {
    const history = useHistory();
    const params = useParams();
    const { device } = useViewport();
    const { t } = useTranslation();

    const [onBeforeChange, setOnBeforeChange] = useState({ action: (proceed) => proceed() });
    const [selected, _setSelected] = useState(device === 'mobile' ? '' : 'edit-profile');
    const [alertDialog, setAlertDialog] = useState({
        open: false,
        message: '',
        description: '',
        note: '',
        variant: 'destructive',
        actionButtonText: t('controls.leave', 'Leave'),
        cancelButtonText: t('controls.cancel', 'Cancel'),
        onAction: () => {},
        onCancel: () => setAlertDialog((current) => ({ ...current, open: false })),
        onClose: () => setAlertDialog((current) => ({ ...current, open: false })),
    });

    const setSelected = (selected) => {
        history.push(`/profile/${selected}`);
    };

    const getContent = (key) => {
        return {
            'edit-profile': (
                <EditProfile
                    setSelected={setSelected}
                    setAlertDialog={setAlertDialog}
                    setOnBeforeChange={setOnBeforeChange}
                />
            ),
            'general-settings': <Language />,
        }[key];
    };

    const options = [
        {
            key: 'edit-profile',
            value: t('account-settings.profile.title', 'Edit Profile'),
            content: getContent('edit-profile'),
        },
        {
            key: 'general-settings',
            value: t('account-settings.general-settings.title', 'General Settings'),
            content: getContent('general-settings'),
        },
    ];

    const props = {
        options,
        selected,
        onBeforeChange: onBeforeChange.action,
        onChange: setSelected,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    useEffect(() => {
        if (params.tab) {
            _setSelected(params.tab);
        }
    }, [params]);

    useEffect(() => {
        if ((device === 'tablet' || device === 'desktop') && !selected) {
            _setSelected('edit-profile');
        }
    }, [device, selected]);

    useEffect(() => {
        setOnBeforeChange({ action: (proceed) => proceed() });
    }, [selected]);

    if (device !== 'mobile' && !props.options.some(({ key }) => key === selected)) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <AlertDialog {...alertDialog} />
        </>
    );
};

export default ProfilePage;
